<template>

  <div class="card directory-list-card directory-management-card">
    <div class="card-header directory-list-card__header">
      <div class="directory-list-card__title">
        <h4>{{ $t('Office Directory') }}</h4>
      </div>
    </div>
    <div class="card-body directory-management-card__body">
      <div class="directory-management-grid">
        <div class="directory-management-form-panel">
          <OfficeForm></OfficeForm>
        </div>
        <div class="directory-management-list-panel">
          <Loader v-if="officeList.totalDocs===undefined"></Loader>
          <OfficeList v-else></OfficeList>
        </div>
      </div>
    </div>
  </div>

  <Modal idModal="UpdateOfficeModal" :headerTitle="$t('Edit Office')">
    <div class="user-modal-form">
      <div class="form-group">
        <label :class="{ 'required-style': !officeDataUpdate.officeName }">{{ $t('Office Name') }}</label>
        <input type="text" class="form-control" v-model="officeDataUpdate.officeName" :placeholder="$t('Office Name')"/>
        <span class="text-warning" v-if="!officeDataUpdate.officeName && isUpdateClicked">{{ $t('Required') }}</span>
      </div>
      <div class="form-group">
        <label :class="{ 'required-style': !officeDataUpdate.regionId }">{{ $t('Region') }}</label>
        <select class="form-select text-capitalize" v-model="officeDataUpdate.regionId">
            <option value="">{{ $t('Select Region') }}</option>
            <option v-for="(item, key) in regionDropDownList" :key="key" :value="item._id">{{item.regionName}}</option>
        </select>
        <span class="text-warning" v-if="!officeDataUpdate.regionId && isUpdateClicked">{{ $t('Required') }}</span>
      </div>
    </div>
    <template v-slot:actions>
    <button type="button" ref="closeAddModal" class="btn user-modal-btn user-modal-btn--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
    <button class="btn user-modal-btn user-modal-btn--submit" ref="updateBtn" @click="UpdateOffice">{{ $t('Save Changes') }}</button>
    </template>
  </Modal>


</template>

<script>
import OfficeList from '@/components/directoryInfo/Office/OfficeList.vue'
import OfficeForm from '@/components/directoryInfo/Office/OfficeForm.vue'
import Modal from '@/components/layout/Modal.vue'
import Loader from '@/components/layout/Loader.vue'
import {mapGetters, mapActions} from 'vuex'
import { LinkList } from '@/helpers/utilities.js'
import {showDirectoryError} from '@/helpers/directoryErrorAlert.js'
import {showDirectorySuccess} from '@/helpers/directorySuccessAlert.js'
import {showDirectoryLoading, closeDirectoryLoading} from '@/helpers/directoryLoadingAlert.js'

export default {
  name: 'User',
  data(){
    return {
      isUpdateClicked : false
    }
  },
  components: {
    OfficeList,
    OfficeForm,
    Modal,
    Loader
  },
  mounted : function(){
    this.GetRegionListDropdown().catch()
    this.GetOfficeList().catch()
    this.$store.commit('setActiveLink',LinkList.MAIN_COMPANY)
  },
  methods : {
    ...mapActions(['GetOfficeList','GetRegionListDropdown','UpdateOfficeRun']),
    UpdateOffice(){
      const self = this
      const btn = self.$refs.updateBtn
      let data = self.officeDataUpdate
      self.isUpdateClicked = true
      if(!data.officeName || !data.regionId){
        return
      }
      
      btn.disabled = true
      self.isUpdateClicked = false
      showDirectoryLoading(self, {
        title: 'Updating Office',
        description: 'Saving the office changes and updating the directory.'
      })

      self.UpdateOfficeRun(data).then((res)=>{
          btn.disabled = false
          if(res=="OK"){
              self.$refs.closeAddModal.click()
              closeDirectoryLoading(self)
              showDirectorySuccess(self, {
                description: 'The office details have been updated successfully.'
              })
          }else{
              closeDirectoryLoading(self)
              showDirectoryError(self, {
                description: res,
                duplicateValue: data.officeName
              })
          }
      }).catch((error)=>{
          btn.disabled = false
          closeDirectoryLoading(self)
          showDirectoryError(self, {
            description: error?.message || 'Unable to update office. Please try again.',
            duplicateValue: data.officeName
          })
      })
    }
  },
  computed : mapGetters(['officeList','regionDropDownList', 'officeDataUpdate'])
}
</script>
